
var acc = document.getElementsByClassName("ns-accordion-header");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    var item = this.parentElement;
    var panel = this.nextElementSibling;
    var isActive = item.classList.contains("active");

    var allItems = document.getElementsByClassName("ns-accordion-item");
    for (var j = 0; j < allItems.length; j++) {
      allItems[j].classList.remove("active");
      allItems[j].querySelector(".ns-accordion-content").style.maxHeight = null;
    }

    if (!isActive) {
      item.classList.add("active");
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

function initSlider() {
  if (window.innerWidth < 768) {
    if (!$('.ns-overflow-section-bottom-slider').hasClass('slick-initialized')) {
      $('.ns-overflow-section-bottom-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        infinite: false,
        useTransform: false,
        variableWidth: true
      });

      setTimeout(function() {
        $(window).trigger('resize.slick');
      }, 200);
    }
  } else {
    if ($('.ns-overflow-section-bottom-slider').hasClass('slick-initialized')) {
      $('.ns-overflow-section-bottom-slider').slick('unslick');
    }
  }
}

initSlider();

$(window).on('resize', function() {
  initSlider();
});
